import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  flexGrow: 1,
  alignItems: 'flex-end',

  '& > .MuiTypography-root': {
    fontSize: 14,
    lineHeight: '20px',
  },
});

export default StyledBox;
